import React from 'react'
import { Upload, message } from 'antd';
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import API from '@/api'

class UploadComponent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      loading: false,
      // imageUrl: "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2476207596,2966711967&fm=26&gp=0.jpg",
      uploadConfig: {
        name: 'file',
        data: {},
        multiple: false,
        listType: "picture-card",
        showUploadList: false,
        multiple: true,
        action: '',
        beforeUpload: this.beforeUpload,
        onChange: this.onChange
      }
    }
  }

  getUploadParams = async file => {
    const res = await API.GetOssPostObjectParams({
      path: 'blog'
    })
    if (res.code !== 200) return
    const { result: params } = res

    const fileType = file.name.split('.').pop()
    const key = `${params.fileName}.${fileType}`
    const policy = params.policy
    const ossAccessKeyId = params.OSSAccessKeyId
    const signature = params.signature

    const formData = {
      key,
      policy,
      OSSAccessKeyId: ossAccessKeyId,
      signature
    }

    this.setState(prevState => {
      return {
        uploadConfig: {
          ...prevState.uploadConfig,
          action: params.host,
          data: formData
        }
      }
    })
  }

  beforeUpload = async (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }

    await this.getUploadParams(file)

    return isJpgOrPng && isLt2M;
  }

  onChange = (info) => {
    const { status } = info.file;

    this.setState({ loading: status === 'uploading' });

    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
      this.setState({ loading: false });

      this.props.onChange(`http://public.nuiii.com/${this.state.uploadConfig.data.key}`)
    }

    if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  }

  render () {
    const { imageUrl } = this.props
    const { uploadConfig, loading } = this.state

    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

    return (
      <div>
        <Upload {...uploadConfig}>
          {imageUrl && !loading
            ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
            : uploadButton}
        </Upload>
      </div>
    )
  }
}

export default UploadComponent